import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VitalityblastRoutingModule } from './vitalityblast-routing.module';
import { VitalityblastComponent } from './vitalityblast/vitalityblast.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { IndiatourmatchComponent } from './indiatourmatch/indiatourmatch.component';
import { FaqsComponent } from './faqs/faqs.component';
import { WomensinternationalComponent } from './womensinternational/womensinternational.component';
import { RegisterYourInterestComponent } from './register-your-interest/register-your-interest.component';
import { RegisterYourInterestWomenComponent } from './register-your-interest-women/register-your-interest-women.component';

@NgModule({
  declarations: [VitalityblastComponent, IndiatourmatchComponent, FaqsComponent, WomensinternationalComponent, RegisterYourInterestComponent, RegisterYourInterestWomenComponent,],
  imports: [
    CommonModule,
    VitalityblastRoutingModule,
    FormsModule,
    SharedModule,
    OwlDateTimeModule, 
    OwlNativeDateTimeModule
  ]
})
export class VitalityblastModule { }
